"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.UpdateBrand = UpdateBrand;
exports.batchChangeAmt = batchChangeAmt;
exports.getAdminType = getAdminType;
exports.getAllBrand = getAllBrand;
exports.getAllCompany = getAllCompany;
exports.getAllSupplier = getAllSupplier;
exports.getAllUser = getAllUser;
exports.getAmt = getAmt;
exports.getAppId = getAppId;
exports.getCities = getCities;
exports.getComDetail = getComDetail;
exports.getCustomerId = getCustomerId;
exports.getDesignAuthSelectList = getDesignAuthSelectList;
exports.getHomeType = getHomeType;
exports.getMaintainerList = getMaintainerList;
exports.getOperationPlatform = getOperationPlatform;
exports.getSettingDetail = getSettingDetail;
exports.getTemplateSelect = getTemplateSelect;
exports.saveCities = saveCities;
exports.submitSetting = submitSetting;
var _request = _interopRequireDefault(require("@/utils/request"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
function getHomeType() {
  var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
  console.log("身份类型", JavaInfo.homeType);
  return JavaInfo.type === 5;
}
function getAdminType() {
  var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
  console.log("身份类型", JavaInfo.homeType);
  return JavaInfo.type === 1;
}
function getCustomerId() {
  // 从 Cookie 中的 JavaInfo 获取 customerId
  try {
    var javaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
    console.log('获取customerId', javaInfo);
    return javaInfo.customerId || 0;
  } catch (e) {
    console.error('获取 customerId 失败:', e);
  }
  return 0;
}

/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    companyId = _ref.companyId,
    companyName = _ref.companyName,
    cooperationStatus = _ref.cooperationStatus,
    maintainerId = _ref.maintainerId,
    creatorId = _ref.creatorId,
    supplierName = _ref.supplierName,
    supplierType = _ref.supplierType,
    platformId = _ref.platformId,
    writeOffType = _ref.writeOffType,
    customerId = _ref.customerId,
    createTimeStart = _ref.createTimeStart,
    createTimeEnd = _ref.createTimeEnd,
    page = _ref.page,
    limit = _ref.limit,
    hasActiveActivity = _ref.hasActiveActivity;
  var data = {
    companyId: companyId,
    companyName: companyName,
    cooperationStatus: cooperationStatus,
    maintainerId: maintainerId,
    creatorId: creatorId,
    supplierName: supplierName,
    supplierType: supplierType,
    writeOffType: writeOffType,
    platformId: platformId,
    customerId: customerId,
    createTimeStart: createTimeStart,
    createTimeEnd: createTimeEnd,
    page: page,
    limit: limit,
    hasActiveActivity: hasActiveActivity
  };
  return (0, _request.default)({
    url: '/admin/business/supplier/list',
    method: 'GET',
    params: data
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var companyId = datas.companyId,
    supplierName = datas.supplierName,
    account = datas.account,
    password = datas.password,
    cooperationStatus = datas.cooperationStatus,
    ticketType = datas.ticketType,
    settlementMethodText = datas.settlementMethodText,
    contactName = datas.contactName,
    contactPosition = datas.contactPosition,
    contactPhone = datas.contactPhone,
    maintainerId = datas.maintainerId,
    weChatGroupName = datas.weChatGroupName,
    writeOffType = datas.writeOffType,
    remark = datas.remark,
    supplierType = datas.supplierType,
    _datas$brandList = datas.brandList,
    brandList = _datas$brandList === void 0 ? [] : _datas$brandList,
    advanceReservation = datas.advanceReservation,
    _datas$serviceTimes = datas.serviceTimes,
    serviceTimes = _datas$serviceTimes === void 0 ? [] : _datas$serviceTimes,
    logo = datas.logo,
    _datas$miniProgramLis = datas.miniProgramList,
    miniProgramList = _datas$miniProgramLis === void 0 ? [] : _datas$miniProgramLis;
  var _ref2 = companyId && companyId.split('_') || [],
    _ref3 = _slicedToArray(_ref2, 2),
    companyValue = _ref3[0],
    companyName = _ref3[1];
  return {
    companyId: companyValue ? Number(companyValue) : null,
    companyName: companyName,
    supplierName: supplierName,
    account: account,
    password: password,
    cooperationStatus: cooperationStatus,
    ticketType: ticketType,
    settlementMethodText: settlementMethodText,
    contactName: contactName,
    contactPosition: contactPosition,
    contactPhone: contactPhone,
    maintainerId: maintainerId,
    weChatGroupName: weChatGroupName,
    writeOffType: writeOffType,
    // 供货折扣率（前端传整数百分比，例如 80）
    discountRate: datas.discountRate === undefined || datas.discountRate === null ? 100 : Number(datas.discountRate),
    remark: remark,
    supplierType: supplierType,
    brandList: brandList,
    advanceReservation: advanceReservation,
    serviceTimes: serviceTimes,
    logo: logo,
    miniProgramList: miniProgramList
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(pram) {
  return (0, _request.default)({
    url: '/admin/business/supplier/save',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(pram) {
  return (0, _request.default)({
    url: '/admin/business/supplier/update',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}
/**
 * 保持关联品牌
 * @param pram
 * @constructor
 */
function UpdateBrand(pram) {
  return (0, _request.default)({
    url: '/admin/business/supplier/updateBrand',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
function DelArticle(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/business/supplier/delete',
    method: 'GET',
    params: data
  });
}
function getAppId(id) {
  return (0, _request.default)({
    url: '/admin/business/supplier/getPrivateKey',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
function getComDetail(id) {
  return (0, _request.default)({
    url: '/admin/business/supplier/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 修改配置
 * @param {*} pram
 * @returns
 */
function submitSetting(pram) {
  var _ref4 = pram || {},
    balanceQueryAddress = _ref4.balanceQueryAddress,
    callbackDomain = _ref4.callbackDomain,
    id = _ref4.id,
    interfaceTemplate = _ref4.interfaceTemplate,
    merchantId = _ref4.merchantId,
    orderAddress = _ref4.orderAddress,
    queryAddress = _ref4.queryAddress,
    signatureKey = _ref4.signatureKey,
    supplierId = _ref4.supplierId,
    supplierKey = _ref4.supplierKey;
  return (0, _request.default)({
    url: '/admin/business/supplier/config/save',
    method: 'post',
    data: {
      balanceQueryAddress: balanceQueryAddress,
      callbackDomain: callbackDomain,
      id: id,
      interfaceTemplate: interfaceTemplate,
      merchantId: merchantId,
      orderAddress: orderAddress,
      queryAddress: queryAddress,
      signatureKey: signatureKey,
      supplierId: supplierId,
      supplierKey: supplierKey
    }
  });
}

/**
 * 配置详情
 * @param id
 * @constructor
 */
function getSettingDetail(id) {
  return (0, _request.default)({
    url: '/admin/business/supplier/config/info',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 查询余额
 * @param id
 * @constructor
 */
function getAmt(id) {
  return (0, _request.default)({
    url: '/admin/business/supplier/getBalance',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取公司
 * @param {*} keyword
 * @returns
 */
function getAllCompany(keyword) {
  return (0, _request.default)({
    url: "/admin/business/company/autoList",
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

// 获取运营平台列表
function getOperationPlatform() {
  return (0, _request.default)({
    url: '/admin/companyapp/autoList',
    method: 'GET'
  });
}

/**
 * 查询操作人
 * @param {*} keyword
 * @returns
 */
function getAllUser(keyword) {
  return (0, _request.default)({
    url: "/admin/system/admin/autoList",
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 查询品牌
 */
function getAllBrand(keyword) {
  return (0, _request.default)({
    url: '/admin/store/brand/autoList',
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 查询销售商
 */
function getAllSupplier(keyword) {
  return (0, _request.default)({
    url: '/admin/business/supplier/autoList',
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 批量改价
 * @param {*} data
 * @returns
 */
function batchChangeAmt(data) {
  return (0, _request.default)({
    url: '/admin/business/supplierProduct/updateBatch',
    method: 'post',
    data: data
  });
}

/**
 * 接口模版查询
 * @param {*} keyword
 * @returns
 */
function getTemplateSelect(keyword) {
  return (0, _request.default)({
    url: "/admin/api/template/autoList",
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 根据suppierId查询城市服务
 */
function getCities(supplierId) {
  return (0, _request.default)({
    url: "/admin/suppier/domestic-stores/getCities/".concat(supplierId),
    method: 'GET',
    params: {
      supplierId: supplierId
    }
  });
}

/**
 * 保存城市服务
 */
function saveCities(data) {
  return (0, _request.default)({
    url: "/admin/suppier/domestic-stores/saveCities/".concat(data.supplierId),
    method: 'post',
    data: data
  });
}

/**
 * 获取供应商维护人列表（下拉用）
 */
function getMaintainerList() {
  return (0, _request.default)({
    url: '/admin/business/supplier/maintainer/list',
    method: 'GET'
  });
}

/**
 * 核销链接选择器列表（不分页）
 * @param {String} keyword 链接名称（designAuthName）
 */
function getDesignAuthSelectList(keyword) {
  return (0, _request.default)({
    url: '/admin/company-design-auth/select/list',
    method: 'GET',
    params: {
      designAuthName: keyword || ''
    }
  });
}